export function register() {
  if (!('serviceWorker' in navigator)) return;

  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // Suppress service worker registration logs in development
        if (process.env.NODE_ENV === 'production') {
          console.log('SW registered: ', registration);
        }

        // Fire update event if there's already a waiting worker
        if (registration.waiting) {
          window.dispatchEvent(new CustomEvent('sw-update-available', { detail: { registration } }));
        }

        // Detect new updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                window.dispatchEvent(new CustomEvent('sw-update-available', { detail: { registration } }));
              }
            });
          }
        });
      })
      .catch((registrationError) => {
        // Suppress service worker registration errors in development
        if (process.env.NODE_ENV === 'production') {
          console.log('SW registration failed: ', registrationError);
        }
      });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
